/// <reference path="../typings/index.d.ts"/>

import * as React from "react";
import * as ReactDOM from "react-dom";

import { App } from "./components/App";

function getQueryVariable(variable: string) {
    const query: string = window.location.search.substring(1);
    const vars: string[] = query.split('&');
    for (const group of vars) {
        const [key, value] = group.split('=');
        if (decodeURIComponent(key) === variable) {
            return decodeURIComponent(value);
        }
    }
    console.log('Query variable %s not found', variable);
    return null;
}

// Initialize Firebase
var config = {
    apiKey: "AIzaSyD_pDiNyA7uWvFI80sb4hycyALXkqbYgls",
    authDomain: "lapface-d1564.firebaseapp.com",
    databaseURL: "https://lapface-d1564.firebaseio.com",
    storageBucket: "lapface-d1564.appspot.com",
};
window.firebase.initializeApp(config);

ReactDOM.render(<App />, document.getElementById("root"));



/** WEBPACK FOOTER **
 ** ./src/index.tsx
 **/